import { ConnectedProps, connect } from "react-redux";
import { withRouter } from "react-router";
import { ExperiencesAvailability } from "./component";
import { IStoreState } from "../../reducers/types";
import {
  getEntryType,
  getFromDate,
  getLocation,
  getUntilDate,
  getLodgingId,
} from "../search/reducer";
import {
  ExperiencesAvailabilityCallState,
  getExperiencesAvailabilityCallState,
  getExperiencesByCategoryMap,
  getExperiencesMap,
  getFiltersChangedSinceLastSearch,
  getParsedExperiencesByCategory,
  getExperiencesCategoryTags,
  getPriceFiltersChangedSinceLastSearch,
  getSortOption,
  getSelectedGroupedExperience,
  getExperiencesAvailabilityNextPageToken,
  getAllAppliedFiltersList,
  getActivitiesAvailabilityProperties,
  getUserHasBookedActivities,
  getViewPreference,
  getAvailabilityFilterPills,
} from "./reducer";
import {
  getFetchRewardsAccountsCallState,
  getRewardsAccountWithLargestValue,
  getSelectedAccount,
  getSelectedAccountReferenceIdIfRedemptionEnabled,
} from "../rewards/reducer";
import {
  fetchInitialExperiencesAvailability,
  getAvailabilityRequestParameters,
  fetchFilteredExperiencesAvailability,
  setSortOption,
  fetchMoreExperiencesAvailability,
  setFilterTags,
  resetFilterAndSort,
  resetExperiencesAvailability,
  setSelectedGroupedExperience,
  fetchBookedActivities,
  setViewPreference,
} from "./actions/actions";
import { fetchTravelWalletDetails } from "../travel-wallet/actions/actions";
import { setCategoryTagId } from "../search/actions/actions";
import { getFetchTravelWalletDetailsCallState } from "../travel-wallet/reducer";
import {
  getActivityDetailsProperties,
  getSelectedExperienceId,
} from "../shop/reducer";

const mapStateToProps = (state: IStoreState) => {
  const experiencesAvailabilityCallState =
    getExperiencesAvailabilityCallState(state);
  const isReadyToFetchMoreExperiences =
    experiencesAvailabilityCallState ===
      ExperiencesAvailabilityCallState.FollowUpSearchCallSuccess ||
    experiencesAvailabilityCallState ===
      ExperiencesAvailabilityCallState.InitialSearchCallSuccess;

  return {
    isReadyToFetchMoreExperiences,
    fromDate: getFromDate(state),
    untilDate: getUntilDate(state),
    location: getLocation(state),
    experiencesAvailabilityCallState:
      getExperiencesAvailabilityCallState(state),
    largestValueAccount: getRewardsAccountWithLargestValue(state),
    fetchRewardsAccountsCallState: getFetchRewardsAccountsCallState(state),
    experiencesMap: getExperiencesMap(state),
    experiencesByCategory: getParsedExperiencesByCategory(state),
    categoryTags: getExperiencesCategoryTags(state),
    availabilityFilterPills: getAvailabilityFilterPills(state),
    rewardsKey: getSelectedAccountReferenceIdIfRedemptionEnabled(state),
    filtersChangedSinceLastSearch: getFiltersChangedSinceLastSearch(state),
    priceFiltersChangedSinceLastSearch:
      getPriceFiltersChangedSinceLastSearch(state),
    sortOption: getSortOption(state),
    experiencesByCategoryMap: getExperiencesByCategoryMap(state),
    selectedGroupedExperience: getSelectedGroupedExperience(state),
    availabilityNextPageToken: getExperiencesAvailabilityNextPageToken(state),
    appliedFiltersList: getAllAppliedFiltersList(state),
    fetchTravelWalletDetailsCallState:
      getFetchTravelWalletDetailsCallState(state),
    activitiesAvailabilityProperties:
      getActivitiesAvailabilityProperties(state),
    activitiesDetailsProperties: getActivityDetailsProperties(state),
    selectedRewardsAccount: getSelectedAccount(state),
    entryType: getEntryType(state),
    lodgingId: getLodgingId(state),
    // the user should see the survey if they have selected an activity and are going back to the availability page and they've never booked an activity before
    hasBookedActivities: getUserHasBookedActivities(state),
    fromActivityShopPage: getSelectedExperienceId(state) !== undefined,
    viewPreference: getViewPreference(state),
  };
};

const mapDispatchToProps = {
  fetchInitialExperiencesAvailability,
  fetchMoreExperiencesAvailability,
  fetchFilteredExperiencesAvailability,
  getAvailabilityRequestParameters,
  setSortOption,
  setFilterTags,
  fetchTravelWalletDetails,
  resetFilterAndSort,
  resetExperiencesAvailability,
  setSelectedGroupedExperience,
  setCategoryTagId,
  fetchBookedActivities,
  setViewPreference,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type ExperiencesAvailabilityConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedExperiencesAvailability = withRouter(
  connector(ExperiencesAvailability)
);
